const state = {
    app: {
        main: {
            classes: ['py-4'],
        },
    },
};

const mutations = {
    CLASS_PUSH(state, params) {
        _.set(state, params.path, params.value);
    },
    CLASS_REMOVE(state, params) {
        _.set(state, params.path, _.values(_.reject(_.get(state, params.path, []), (c) => {
            return c == params.value;
        })));
    },
};


const actions = {
    classPush({ commit, state }, params) {
        commit('CLASS_PUSH', params);
    },
    classRemove({ commit, state }, params) {
        commit('CLASS_REMOVE', params);
    },
};

const getters = {
    all(state, getters, rootState) {
        return state;
    },
};

export default {
    state,
    actions,
    getters,
    mutations,
}
